<section>
	<div [formGroup]="form" class="main">
		<div class="field-block">
			<label i18n>Экспортировать файл</label>
			<p-dropdown
				[disabled]="disableSelect"
				[options]="selectTypeValues"
				formControlName="selectType"
				optionLabel="name"
				appendTo="body"
				panelStyleClass="h3r">
			</p-dropdown>
		</div>
		<div class="field-block">
			<span>
				<app-checkbox formControlName="isBase64"></app-checkbox>
				<label i18n>Экспорт файла с кодами в Base64</label>
			</span>
		</div>
	</div>
    <footer>
		<button i18n type="button" class="save" appSkin="action-save bold" (click)="export()">Экспорт</button>
		<button i18n type="button" appSkin="simple no-shadow bold bordered" (click)="close()">Закрыть</button>
	</footer>
</section>
